
export default {
    vi: {
        summary: 'Tổng quan',
        salaryComponent: 'Thành phần lương',
        salaryTablePattern: 'Mẫu bảng lương',
        salaryData: 'Dữ liệu tính lương',
        signOut: 'Đăng xuất'
    },
    en: {
        summary: 'Summary',
        salaryComponent: 'Salary components',
        salaryTablePattern: 'Salary table pattern',
        salaryData: 'Salary data',
        signOut: 'Sign out'
    }
};